/* eslint-disable linebreak-style */
export const StyledModal = {

  '@media (min-width:668px)': {
  },

  '@media (min-width:1025px)': {
  }
};

export const StyledBoxContainer = {
  display: 'flex',
  flexDirection: 'column',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: '450px',
  bgcolor: 'background.paper',
  border: '1px solid #ccc',
  borderRadius: '6px',
  boxShadow: 24,
  px: 2,
  pt: 1.5,
  pb: 2
};

export const StyledCloseBtnBox = {
  display: 'flex',
  justifyContent: 'flex-end'
};

export const StyledCloseBtn = {
  p: 0
};

export const StyledMediaBox = {
  display: 'flex',
  justifyContent: 'center'
};

export const StyledCardMediaImg = {
  padding: 2,
  width: '280px',
  height: '200px',
  objectFit: 'cover'
};

export const StyledTypographyName = {
  fontSize: '24px',
  marginTop: '4px',

  '@media (min-width:668px)': {
    fontSize: '28px'
  },

  '@media (min-width:1025px)': {
    fontSize: '28px'
  }
};

export const StyledIcon = {
  maxWidth: '50px'
};

export const StyledRating = {
  minWidth: '50px',
  fontSize: '20px'
};

export const StyledTypoVic = {
  fontSize: '16px',
  color: 'text.secondary',
  mt: 0.5
};

export const StyledReviewBox = {
  display: 'flex',
  flexDirection: 'column',
  my: '10px'
};

export const StyledTypoReviewTitle = {
  fontSize: '16px',
  fontWeight: '700'
};

export const StyledTypoReview = {
  fontSize: '16px',
  fontWeight: '400',
  mb: 1,
  wordBreak: 'break-all'
};

export const StyledBtnBox = {
  display: 'flex',
  justifyContent: 'space-evenly',
  mt: '20px'
};

export const StyledBottomBtns = {
  width: '50%',
  mr: '2px',
  color: '#446173',
  borderColor: '#446173'
};

export const StyledPlaceTextBox = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  fontSize: '16px',
  gap: '6px',
  justifyContent: 'space-between',
  mt: 1
};

export const StyledPlaceTextIconBox = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '12px'
};
